<template>
  <div class="wrapper modal-attention">
    <button data-modal-close @tap="cancel" @click="cancel">
      <img src="@/assets/images/close.svg" height="20" width="20" alt="close icon"/>
      <span class="visually-hidden">Close modal</span>
    </button>
    <div class="caption">Welcher Grund war für Sie entscheidend, bei AGILA eine Versicherung abzuschließen?</div>

    <a-checkbox radio v-model="attentions" label="Empfehlungen von Freunden oder Bekannten" value="Empfehlungen von Freunden oder Bekannten" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Empfehlung von Tierarztpraxis" value="Empfehlung von Tierarztpraxis" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Preis-Leistungs-Verhältnis" value="Preis-Leistungs-Verhältnis" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Schnelle und problemlose Abwicklung von Kosten" value="Schnelle und problemlose Abwicklung von Kosten" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Deckung spezifischer medizinischer Bedürfnisse (z. B. bestimmte Erkrankungen)" value="Deckung spezifischer medizinischer Bedürfnisse (z. B. bestimmte Erkrankungen)" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Vertrauen in die Seriosität und Zuverlässigkeit von AGILA (30 Jahre Erfahrung)" value="Vertrauen in die Seriosität und Zuverlässigkeit von AGILA (30 Jahre Erfahrung)" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Positive Erfahrungen mit vorherigen Haustieren, die bei AGILA versichert waren" value="Positive Erfahrungen mit vorherigen Haustieren, die bei AGILA versichert waren" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Möglichkeit der Direktabrechnung mit Praxis oder Klinik" value="Möglichkeit der Direktabrechnung mit Praxis oder Klinik" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Positive Bewertungen im Internet" value="Positive Bewertungen im Internet" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Digitale Services wie z. B. Kunden-App oder Help Center" value="Digitale Services wie z. B. Kunden-App oder Help Center" :size="16"/>
    <a-checkbox radio v-model="attentions" label="Anderer Grund:" :size="16"/>
    <a-input type="multiline" label="Anderer Grund" v-model="attentionsOther" no-label />
    <div v-if="error" class="error">Bitte Grund angeben</div>

    <button type="submit" class="btn btn--blue" @click="send">Absenden</button>
  </div>
</template>

<script>

export default {
  data: () => ({
    attentions: '',
    attentionsOther: '',
    error: false,
  }),
  methods: {
    cancel() {
      this.$emit('done')
    },
    send() {
      try {
        if (this.attentions) {
          if (this.attentions === 'Anderer Grund:') {
            if (this.attentionsOther) {
              this.attentions = this.attentionsOther
            } else {
              this.error = true;
              return;
            }
          }
        } else {
          this.error = true;
          return;
        }
        this.$emit('done', this.attentions)
      } catch (e) {
        this.$emit('done')
      }
    }
  },
}

</script>

<style lang="scss">

.modal-attention {
  position: relative;
  min-width: 500px;

  .input-control .wrapper .input {
    padding-top: 0 !important;
  }

  .error {
    margin: 10px 0 0;
  }

  .caption {
    margin-bottom: 20px;
    font-weight: bold;
    color: #014e9e;
    padding-right: 25px;
  }

  .checkbox {
    &.control {
      flex-wrap: nowrap;
      margin-bottom: 5px;

      &.type-radio {
        padding: 0;
      }
    }

    .icon {
      display: block;
    }
  }

  .btn {
    margin-top: 20px;
  }

  [data-modal-close] {
    right: 0;
    top: 0;
    width: 14px;
    height: 14px;
  }
}

</style>
